"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _KnowledgeCss = _interopRequireDefault(require("./Knowledge.css.js"));

var _feedToolz = require("../feed-toolz");

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnItem = function ColumnItem(_ref) {
  var itemIdx = _ref.itemIdx,
      item_data = _ref.item_data,
      styleOverride = _ref.styleOverride;
  var content = item_data.content,
      link = item_data.link,
      title = item_data.title,
      categories = item_data.categories;

  var handleLinkClick = function handleLinkClick(e) {
    e.preventDefault();
    window.open(link, '_blank');
  };

  var fullItemTitleStyle = Object.assign({}, _KnowledgeCss.default['columnItemTitle'], styleOverride['columnItemTitle']);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "".concat(title, "-item-key"),
    style: _KnowledgeCss.default.columnItem
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _feedToolz.getSrcFromHtml)(content, true, 'sm'),
    style: _KnowledgeCss.default.columnItemImage,
    alt: "column-item-img"
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: _KnowledgeCss.default.columnItemContent
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: fullItemTitleStyle,
    onClick: handleLinkClick
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    style: _KnowledgeCss.default.keywordContainer
  }, categories.map(function (category, j) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: _KnowledgeCss.default.keyword,
      key: "".concat(title, "-category-item-").concat(j)
    }, /*#__PURE__*/_react.default.createElement("a", {
      key: "keywords-".concat(itemIdx, "-category-link-").concat(j),
      style: _KnowledgeCss.default.category,
      href: link
    }, /*#__PURE__*/_react.default.createElement("span", null, category)));
  }))));
};

var _default = (0, _radium.default)(ColumnItem);

exports.default = _default;

//# sourceMappingURL=ColumnItem.jsx.map